import React, { useState } from 'react';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import text from './text';

const language = window.location.hash === '#en' ? 'eng' : 'hun';

export default ({layers, onLayersChange}) => {

  const onPropertyChange = (name, key, value) => {
    const newLayers = { ...layers };
    newLayers[name][key] = value;
    onLayersChange(newLayers);
  }

  const changeLayer = (name) => {
    const newLayers = { ...layers };
    //newLayers[name]["visible"] = value;
    if (name=="scatterplot") {
      newLayers["hexagon"]["visible"] = false;
      newLayers["scatterplot"]["visible"] = true;
    }
    else {
      newLayers["hexagon"]["visible"] = true;
      newLayers["scatterplot"]["visible"] = false;
    }
    onLayersChange(newLayers);
  }

  const { baseMap, scatterplot, hexagon, tiles } = layers;
  return (
    <div className="layerOptions option">
       <FormControl component="fieldset">
        <FormLabel component="legend">{text[language].filtersGroupNames.layer}</FormLabel>
        <FormGroup>
{/*           <FormControlLabel
            control={
              <Switch
                checked={baseMap.visible}
                onChange={e => onPropertyChange('baseMap', 'visible', e.target.checked)}
                value="baseMap"
                color="primary"
              />
            }
            label={text[language].layers.hungary}
          /> */}

          <ButtonGroup aria-label="outlined button group">
              <Button
                color={!layers["hexagon"]["visible"]?"primary":""}
                onClick={ e => changeLayer('scatterplot')}
              >
              {text[language].layers.points}
              </Button>
              <Button
              color={layers["hexagon"]["visible"]?"primary":""}
              onClick={ e => changeLayer('hexagon')}
              >{text[language].layers.stick}</Button>
            </ButtonGroup>

          { layers["hexagon"]["visible"] &&
          <div className="layerSettings">
            <FormControl>
              <InputLabel htmlFor="elevationScale">{text[language].layers.sticksHeight}</InputLabel>
              <Select
                value={hexagon.elevationScale}
                onChange={e => onPropertyChange('hexagon', 'elevationScale', e.target.value)}
                inputProps={{
                  name: 'elevationScale',
                  id: 'elevationScale',
                }}
              >
              {
                [100, 300, 500, 800, 1200, 2000, 4000].map((e, i) =>
                <MenuItem key={'scale'+i} value={e}>{i + 1}</MenuItem>
                )
              }
              </Select>
            </FormControl>
            {/* <FormControl>
              <InputLabel htmlFor="radius">{text[language].layers.radius}</InputLabel>
              <Select
                value={hexagon.radius}
                onChange={e => onPropertyChange('hexagon', 'radius', e.target.value)}
                inputProps={{
                  name: 'radius',
                  id: 'radius',
                }}
              >
              {
                [1000, 2000, 3000, 4000, 5000, 6000, 7000].map((e, i) =>
                <MenuItem key={'radius'+i} value={e}>{(i + 1)*2} km</MenuItem>
                )
              }
              </Select>
            </FormControl> */}
          </div>
          }
          {/* <FormControlLabel
            control={
              <Switch
                checked={tiles.visible}
                onChange={e => onPropertyChange('tiles', 'visible', e.target.checked)}
                value="tiles"
                color="primary"
              />
            }
            label={text[language].layers.map}
          /> */}
        </FormGroup>
      </FormControl>
    </div>
  )
}